export default __webpack_public_path__ + "static/media/029-mop.105363aa.svg";